import { useUserInfo } from ".";
import { useHistory } from "react-router";

import { apiFoLogAPI } from '../api/logDataAPI';
import { useCallback } from "react";

export default function useApiLogData() {
  const history = useHistory();
  const { info } = useUserInfo();

  const setApiLogData = useCallback(async ({
    req,
    res,
    resCd,
    apiUrl,
    param,
    userKey,
  }) => {
    const data = {
      sbsceMbrId: info?.userId,
      lrnMbrId: userKey ? userKey : info?.learnerId,
      url: apiUrl,
      location: history.location.pathname,
      req,
      res,
      resCd,
      param1: param?.param1,
      param2: param?.param2,
      param3: param?.param3,
      dummy: ""
    };

    await apiFoLogAPI(data);
  }, [info]);

  return {
    setApiLogData
  }
}